import axios from "axios";
import { Modal } from "antd";

import FileSaver from "file-saver";

const baseapi = process.env.REACT_APP_API + "/api";
export const exportEvents = async (token, client_id) => {
  try {
    const response = await axios.post(
      `${baseapi}/events/export/events/`,
      {
        client_id
      },
      {
        responseType: "arraybuffer",
        headers: {
          Authorization: token
        }
      }
    );

    FileSaver.saveAs(
      new Blob([response.data], { type: "application/vnd.ms-excel" }),
      `Evénements de type speedy et administratif.xlsx`
    );
  } catch (error) {
    const blob = new Blob([error.response.data], {
      type: error.response.headers["content-type"]
    });
    const reader = new FileReader();
    reader.onload = function() {
      Modal.error({
        title: "Erreur",
        content: this.result
      });
    };
    reader.readAsText(blob);
  }
};



// WEBPACK FOOTER //
// src/containers/activite/planning/Events.util.js